import React, { useContext } from "react";
import { Box } from "@mui/material";
import SubdirectoryArrowRightIcon from "@mui/icons-material/SubdirectoryArrowRight";
import { SingleContext } from "gatsby-frontend/src/Page";

function AnchorNav({ headerOffset = 110 }) {
	const { anchors = [] } = useContext(SingleContext);

	function handleClick(e, id) {
		e.preventDefault();
		let target = document.querySelector(`#${id}`);
		if (target) {
			let offsetPosition = target.offsetTop - headerOffset;
			window.scrollTo({
				top: offsetPosition,
				behavior: "smooth",
			});
		}
	}

	return (
		<Box
			component="nav"
			sx={(theme) => ({
				"& a": {
					color: theme.palette.link.main,
					textDecoration: "none",
					display: "inline-block",
					alignItems: "center",
					"& svg": {
						display: "inline-block",
						verticalAlign: "middle",
					},
					"& span": {
						display: "inline-block",
						paddingLeft: theme.spacing(1),
						fontSize: "1.1em",
						verticalAlign: "middle",
					},
					"&:hover, &:active, &:focus": {
						color: theme.palette.link.hover,
						"& span": {
							textDecoration: "underline",
						},
					},
				},
			})}
		>
			{anchors.map((anchor) => (
				<span key={anchor.id}>
					<a href={`#${anchor.id}`} onClick={(e) => handleClick(e, anchor.id)}>
						<SubdirectoryArrowRightIcon /> <span>{anchor.title}</span>
					</a>
					<br />
				</span>
			))}
		</Box>
	);
}

export default AnchorNav;
